/** Mirrors backend `ScheduledCallAttemptState`. */
export enum ScheduledCallAttemptState {
  Queued = 1,
  InProgress = 2,
  Succeeded = 3,
  Failed = 4,
}
